<template>
  <div class="container my-5">
    <div class="row">
      <div class="col-12">
        <div class="alert-information">
          <h5 class="m-0" v-html="$t('alert-contact')"></h5>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
    .alert-information {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 25px;
        background-color: #f3f5f3;
        font-family: var(--montserrat-bold);
        color: var(--primary-color);
    }

    h5 {
        line-height: 40px;
    }
</style>
